import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAlerts } from "service/policy/getAlerts";
import { isAgentPortal } from "js/utilities";

import getCompanyWideAlerts from "service/CSRAdminAlerts/GetAlerts";
import config from "config/config";
import moment from "moment/moment";
import { getToken } from "js/formatting/getToken";

async function getCompanyWideAlertArray() {
  let companyWideAlert = [];
  await getCompanyWideAlerts()
    .then((response) => {
      if (response && response?.activeAlerts?.length > 0) {
        let companyWideAlerts = response?.activeAlerts
          .filter(
            (a) =>
              moment(a.startDate) <= moment() &&
              a.group?.toLowerCase() === "companywide"
          )
          .map((alert) => {
            return {
              ...alert,
              type: "Company Alert",
              document: {
                typeOfDocument: "Company Alert",
                description: alert?.message,
                PortalDisplayName: "COMPANY ALERTS",
              },
            };
          });
        companyWideAlert.push(...companyWideAlerts);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  return companyWideAlert;
}

async function getPolicyAlerts(policies, user) {
  let AlertsMessage = [];
  if (policies) {
    await getAlerts(policies, user)
      .then((response) => {
        if (response?.success) {
          response?.gIdpPayLoad?.policyHolder?.alerts?.map((a) => {
            let alerts = a?.messages?.map((policyAlerts) => {
              return {
                ...policyAlerts,
                oldPolicy: a?.memberID,
                type: "alert",
                document: {
                  typeOfDocument: "Alerts",
                  description: policyAlerts?.message,
                  PortalDisplayName: "ALERTS",
                },
                policy: {
                  contractID: a?.memberID,
                },
              };
            });
            AlertsMessage.push(...alerts);
          });
        }
      })
      .catch((error) => console.error("getAlerts failing", error));
  }
  return AlertsMessage;
}

export const getCorrespondenceList = createAsyncThunk(
  "getCorrespondenceList",
  async (payload, { getState, rejectWithValue, fulfillWithValue }) => {
    let AlertsMessage = [];

    try {
      let allAlerts = [],
        allCategories = [],
        categoryCounter = {},
        CorrespondenceList = [];
      if (payload?.policyId?.length > 0) {
        for (let i = 0; i < payload.policyId.length; i++) {
          let options = {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `bearer ${getToken()}`,
            },
            body: JSON.stringify({
              contractId: payload.policyId[i],
              agentId: "",
              beginDate: payload.beginDate,
              endDate: payload.endDate,
              portal: isAgentPortal() ? "agent" : "customer",
            }),
          };

          const response = await fetch(
            config.REG_API_BASE_URL + "/forms/correspondence",
            options
          );

          // if (!response.ok) {
          //   return rejectWithValue(response);
          // }

          const data = await response.json();
          if (data?.gXdpApi?.success) {
            // find current policy from data store
            let currentPolicy = isAgentPortal()
              ? payload?.agentPolicies?.filter(
                  (policy) => policy.contractID === payload.policyId[i]
                )
              : getState().data.policies.filter(
                  (policy) => policy.contractID === payload.policyId[i]
                );
            CorrespondenceList.push(
              ...data.gXdpApi.gIdpPayLoad.images.map((image) => {
                image.policy.status = currentPolicy[0].status;
                return {
                  ...image,
                };
              })
            );
          }
        }

        allAlerts = CorrespondenceList;
        // get Policy Alerts
        // exclude policy alerts if we are on the policies page in the Agent Portal
        if (
          !(
            isAgentPortal() &&
            window.location.pathname.split("/").includes("policies")
          )
        ) {
          let policyAlerts = await getPolicyAlerts(
            isAgentPortal() ? payload.agentPolicies : getState().data.policies,
            getState().user?.user
          );
          if (policyAlerts?.length > 0) {
            allAlerts = CorrespondenceList.concat(policyAlerts);
          }
        }

        // get Company Alerts
        let companyWideAlertArray = await getCompanyWideAlertArray();

        if (companyWideAlertArray?.length > 0) {
          let AlertArray = allAlerts.concat(companyWideAlertArray);
          allAlerts = AlertArray;
        }

        allAlerts.map((image) => {
          if (!categoryCounter.hasOwnProperty(image.document.typeOfDocument)) {
            allCategories.push({
              type: image?.type,
              ...image.document,
            });
            categoryCounter[image.document.typeOfDocument] = 1;
          }
        });
        return fulfillWithValue({
          allAlerts,
          allCategories,
        });
      } else if (payload.agentId) {
        let options = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `bearer ${getToken()}`,
          },
          body: JSON.stringify({
            agentId: payload.agentId,
            contractId: "",
            beginDate: payload.beginDate,
            endDate: payload.endDate,
            portal: isAgentPortal() ? "agent" : "customer",
          }),
        };

        const response = await fetch(
          config.REG_API_BASE_URL + "/forms/correspondence",
          options
        );

        if (!response.ok) {
          return rejectWithValue(response);
        }

        const data = await response.json();
        if (data?.gXdpApi?.success) {
          // find current policy from data store
          if (data.gXdpApi.gIdpPayLoad.images?.length > 0) {
            data.gXdpApi.gIdpPayLoad.images.map((image) => {
              let policy = payload?.agentPolicies?.filter(
                (x) => x.contractID === image.policy.contractID
              );
              image.policy.status = policy.status;
              return {
                ...image,
              };
            });
            allAlerts.push(...data.gXdpApi.gIdpPayLoad.images);
            if (AlertsMessage?.length > 0) allAlerts.push(...AlertsMessage);
            allAlerts.map((image) => {
              if (
                !categoryCounter.hasOwnProperty(image.document.typeOfDocument)
              ) {
                allCategories.push({
                  type: image?.type,
                  ...image.document,
                });
                categoryCounter[image.document.typeOfDocument] = 1;
              }
            });
          } else if (AlertsMessage?.length > 0) {
            AlertsMessage.map((image) => {
              if (
                !categoryCounter.hasOwnProperty(image.document.typeOfDocument)
              ) {
                allCategories.push({
                  type: image?.type,
                  ...image.document,
                });
                categoryCounter[image.document.typeOfDocument] = 1;
              }
            });
          }
          return fulfillWithValue({
            allAlerts,
            allCategories,
          });
        } else if (AlertsMessage?.length > 0) {
          allAlerts.push(...AlertsMessage);
          allAlerts.map((image) => {
            if (
              !categoryCounter.hasOwnProperty(image.document.typeOfDocument)
            ) {
              allCategories.push({
                type: image?.type,
                ...image.document,
              });
              categoryCounter[image.document.typeOfDocument] = 1;
            }
          });
        } else {
          return rejectWithValue(data?.gXdpApi?.gIdpPayLoad?.errorMessage);
        }
        return fulfillWithValue({
          allAlerts,
          allCategories,
        });
      } else {
        return fulfillWithValue({
          allAlerts,
          allCategories,
        });
      }
    } catch (error) {
      throw rejectWithValue(error.message);
    }
  }
);
